import { connect } from 'react-redux'
import { ToastComponent } from './ToastComponent'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import { resetToast } from 'shared/store/user'
import { push } from 'connected-react-router'

const mapStateToProps = (state: RootState) => {
    const { toast } = state.userState
    const { type, data } = toast
    let label, url, values, urlParams

    switch (type) {
        case 'POINTS':
            label = 'kingdom.challenge.reward.success.points'
            url = 'routes.kingdom.dashboard'
            values = data && data.points
            urlParams = {
                left: true
            }
            break
        default:
            break
    }
    return {
        label,
        url,
        values,
        urlParams
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    resetToast: () => d(resetToast()),
    navigate: (to: string, state?: any) => d(push({ pathname: to, state }))
})

const Toast = connect(mapStateToProps, mapDispatchToProps)(ToastComponent)

export { Toast }
